import React, { useState } from 'react';
import useFlatData from '../../../Base/Hooks/useFlatData';
import ScrollContainer from '../../../Base/Components/ScrollContainer';
import FlatList from '../../../Base/Components/FlatList';
import InsuranceUploadReturnedBatchModal from '../InsuranceUploadReturnedBatch/InsuranceUploadReturnedBatchModal';
import styles from './InsuranceExportsList.module.scss';
import LinkButton from '../../../../Components/Button/LinkButton';
import { Theme } from '../../../../Enums/Theme.enum';
import InsuranceCompanyInsuranceExportGenModal from '../InsuranceCompanyInsuranceExportGen/InsuranceCompanyInsuranceExportGenModal';
import useSocket from '../../../Base/Hooks/useSocket';
import { Socket } from '../../../Base/Enums/Socket.enum';
import useInsuranceExports from '../../Hooks/useInsuranceExports';
import InsuranceExportsListItem from './InsuranceExportsListItem';

interface Props {
	workplaceId: string;
	rootWorkplaceId: string;
}

const wrapperId = 'managerInsuranceExportsList';

const InsuranceExportsList: React.FC<Props> = ({
	workplaceId,
	rootWorkplaceId,
}) => {
	const [isExportOpen, setIsExportOpen] = useState(false);
	const [isUploadOpen, setIsUploadOpen] = useState(false);

	const {
		getFlatInsuranceExports,
		getNextPage,
		data,
		isLoading,
		page,
		setPage,
	} = useInsuranceExports();

	const { flatData, hasMoreData, loadData } = useFlatData(
		getFlatInsuranceExports,
		{
			data: data?.workplaceInsuranceExports?.data,
			totalPages: data?.workplaceInsuranceExports?.meta?.totalPages,
			page: data?.workplaceInsuranceExports?.meta?.page,
		},
		page,
		setPage,
		{
			workplaceId,
		},
	);

	useSocket(Socket.INSURANCE_REPORT_CREATED, () => loadData(true));

	const handleAfterSuccessUpload = () => {
		setIsUploadOpen(false);
		loadData();
	};

	return (
		<div className={styles.wrapper}>
			<div className={styles.controls}>
				<LinkButton
					theme={Theme.BLUE}
					title='component.insuranceExportedBatchesList.newExport'
					onClick={() => setIsExportOpen(true)}
				/>
				<LinkButton
					theme={Theme.BLUE}
					title='component.insuranceExportedBatchesList.uploadFile'
					onClick={() => setIsUploadOpen(true)}
				/>
			</div>
			<ScrollContainer wrapperId={wrapperId}>
				<FlatList
					onRefresh={loadData}
					onLoadMore={getNextPage}
					data={flatData}
					isLoading={isLoading}
					hasMoreData={hasMoreData}
					scrollableTargetId={wrapperId}
					renderItem={item => (
						<InsuranceExportsListItem
							item={item}
							rootWorkplaceId={rootWorkplaceId}
							workplaceId={workplaceId}
						/>
					)}
				/>
			</ScrollContainer>
			{isUploadOpen && (
				<InsuranceUploadReturnedBatchModal
					isOpen
					workplaceId={workplaceId}
					onClose={() => setIsUploadOpen(false)}
					onSuccess={handleAfterSuccessUpload}
				/>
			)}
			{isExportOpen && (
				<InsuranceCompanyInsuranceExportGenModal
					rootWorkplaceId={rootWorkplaceId}
					onClose={() => setIsExportOpen(false)}
					isOpen
				/>
			)}
		</div>
	);
};

export default InsuranceExportsList;
